import { FormValues } from "../../../../../type/manage";

export const getFilteredAppList = (appListAll: any[] | null, platform: string) => {
    if (!appListAll) return [];
    const os = platform.toLowerCase() === 'aos' ? 'android' : 'ios';
    return appListAll.filter((app) => app.platform?.toLowerCase() === os);
};

export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validateEmails = (emails: string[]): string[] => {
    const errors: string[] = [];
    emails.forEach((email, index) => {
        if (email.trim() && !isValidEmail(email)) {
            errors.push(`Email ${index + 1} is invalid`);
        }
    });
    return errors;
};

export const getDefaultFormValues = () => ({
    name: '',
    os: 'AOS',
    select_app: {
        package_name: '',
    },
    ruleId: '',
    hackingType: '',
    osVersion: '',
    communication_channel: 'email',
    emails: [],
    groups: [],
    slack_ids: []
});


export const getCommunicationChannelData = (data: FormValues) => {
    if (data.communication_channel === 'email') {
        return {
            emails: data.emails?.map((email: any) => email.value) || [],
            groupIds: [],
            slackIds: []
        };
    }
    if (data.communication_channel === 'group') {
        return {
            emails: [],
            groupIds: data.groups?.map((group: any) => group.value) || [],
            slackIds: []
        };
    }
    if (data.communication_channel === 'webhook') {
        return {
            emails: [],
            groupIds: [],
            slackIds: data.slackIds?.map((slack: any) => slack.value) || []
        };
    }
    return {
        emails: [],
        groupIds: [],
        slackIds: []
    };
};
